module.exports = __webpack_public_path__ + "215ffc47.png";